module.exports = __webpack_public_path__ + "site/img/14.df56e230.jpg";